import type { ReactNode } from 'react';
import classnames from 'classnames';
import { mediumBreakpoint } from '../../../../../common/constants';
import { useViewportWidth } from '../../../../utils/hooks/useViewportWidth';
import { ChapterTitle } from '../../atoms/chapterTitle/ChapterTitle';
import { HeroText } from '../../atoms/heroText/HeroText';
import { PageTitle } from '../../atoms/pageTitle/PageTitle';
import * as styles from './Hero.module.scss';

interface IHeroProps {
    children?: ReactNode;
    className?: string;
    error?: boolean;
    fullWidth?: boolean;
    imgUrlDesktop: string;
    imgUrlMobile: string;
    isBold?: boolean;
    subtitle?: string;
    title?: string;
}

export function Hero({
    children,
    className,
    error,
    fullWidth,
    imgUrlDesktop,
    imgUrlMobile,
    isBold,
    subtitle,
    title,
}: IHeroProps) {
    const windowWidth = useViewportWidth();
    const imageUrl = windowWidth.width >= mediumBreakpoint ? imgUrlDesktop : imgUrlMobile;

    const heroClasses = classnames(styles.hero, className, { [styles.error]: error });
    const renderSubtitle = () => {
        if (!subtitle) {
            return null;
        }

        return isBold ? <PageTitle>{subtitle}</PageTitle> : <HeroText>{subtitle}</HeroText>;
    };

    return (
        <div
            className={heroClasses}
            style={{ backgroundImage: `url(${imageUrl})` }}
        >
            {title && <ChapterTitle className={styles.chapterTitle}>{title}</ChapterTitle>}
            <div className={fullWidth ? styles.fullWidthHeroTitle : styles.heroTitle}>
                <div className={title ? styles.heroContentSmall : styles.heroContentFull}>{renderSubtitle()}</div>
            </div>
            {children}
        </div>
    );
}
